// src/redux/reducers/siteReducer.js
// import { SET_UI_FEATURE } from "../actions/alerttrendAtion";

import { SET_FEATURE_ACCESS } from "../actions/featureListAction";

// Redux state starting value
const initialState = {
    featureaccess: [],
};
// Reducer Function 
// Reducer receives the current state and dispatched action
const featureListReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FEATURE_ACCESS: // Checks action type.
    // State Update 
    // Redux creates NEW state object. Redux state is immutable.
      return {
        ...state,
        featureaccess: action.payload,
      };
    default:
      return state;
  }
};

/*
FINAL STATE BECOMES
{
   featureaccess: ["ADMIN", "USER"]
}

*/
export default featureListReducer;


/*
            dispatch(action)
                  ↓
            Reducer receives action
                  ↓
            Reducer updates state
                  ↓
            Store updates
                  ↓
            UI rerenders

*/